import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { LoadingState } from "app/components/ui/feedback";
import ErrorBoundary from "app/components/ui/ErrorBoundary";
import HorizontalNav from "app/layout/HorizontalNav";

/**
 * Authenticated application shell: the original horizontal navigation
 * (teal top bar + navy menu bar, unchanged) above a scrolling content area.
 *
 * The content area is a full-height flex column whose child grows to fill it —
 * the same structure as the previous MatX Layout1 — so pages that size
 * themselves with `height: 100%` or `calc(100vh - …)` behave as before.
 */
export default function AppLayout() {
  const { pathname } = useLocation();
  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column", bgcolor: "background.default", overflow: "hidden" }}>
      <Box sx={{ flexShrink: 0, position: "relative", zIndex: 1100 }}>
        <HorizontalNav />
      </Box>

      <Box
        component="main"
        sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflowY: "auto", overflowX: "hidden" }}
      >
        <Box sx={{ flexGrow: 1, minHeight: 0, display: "flex", flexDirection: "column", position: "relative" }}>
          {/* a page that fails shows "couldn't be shown — Retry" here; the menus keep working
              and opening another page clears it */}
          <ErrorBoundary name="page" resetKey={pathname}>
            <Suspense fallback={<LoadingState fullPage label="Loading…" />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </Box>
      </Box>
    </Box>
  );
}
